export default __webpack_public_path__ + "static/comics-aef77f108277f6144f2e2d2f49f3ba8c.png";